import {
  formatDateOrDash,
  formatDateTimeOrDash,
} from '#/utils/date';

function resolveCategoryName(category) {
  if (!category) {
    return '—';
  }

  return category.name || '—';
}

function resolveCategoryLabel(category) {
  if (!category) {
    return '—';
  }

  const codeName = [category.code, category.name].filter(Boolean).join(' ');
  return codeName || category.id || '—';
}

export function mapStockIssueMeta(detail) {
  const lineCount = Array.isArray(detail?.lines)
    ? detail.lines.length
    : (detail?.lineCount != null ? detail.lineCount : null);

  return {
    code: detail?.issueNo || '-',
    status: detail?.status || '',
    categoryName: resolveCategoryName(detail?.category),
    categoryLabel: resolveCategoryLabel(detail?.category),
    issueDate: formatDateOrDash(detail?.issueDate),
    issueReason: detail?.issueReason ?? '',
    remark: detail?.remark || '',
    createDate: formatDateTimeOrDash(detail?.record?.createdAt),
    reviseDate: formatDateTimeOrDash(detail?.record?.updatedAt),
    closeDate: formatDateTimeOrDash(detail?.history?.completedAt),
    lineCount,
  };
}
